<div [ngSwitch]="templatePrefix" *ngIf="!isLoading">
  <!-- HMM spark welcome screen hmm is only in english -->
  <div *ngSwitchCase="'hmm-'" class="grid">
    <div class="grid__col-10 center-item center-text">
      <h2 class="h2" tabindex="-1" dgxAutofocus>All set!</h2>
      <p class="par guts-p-t-1">
        Check out your personalized feed to browse articles, videos, <br />
        and lessons that will help you develop your skills.
      </p>
      <div class="guts-p-t-2">
        <img
          [src]="getBlobUrl('/content/img/onboarding/party.svg')"
          [alt]="i18n.Onboarding_Step1IdeasImgAlt"
        />
      </div>
    </div>
  </div>

  <!-- There is no default lxp/DSA/DSI last step page redirects user to profile-->
</div>
